import { useState, useEffect } from "react";
import api from "../../../helpers/api";

export const useBranches = (initialSearchTerm = "") => {
  const [branchList, setBranchList] = useState([]);
  const [branchListTable, setBranchListTable] = useState([]);
  const [searchBranchName, setSearchBranchName] = useState(initialSearchTerm);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBranches = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const res = await api.getBranch(searchBranchName);
        if (res.statusCode === 200) {
          // Save original branch data for normal selection
          setBranchList(res.data.data);

          // Add "All Branches" option for table filter
          const newBranch = {
            id: "",
            branchName: "All Branches",
            address: "",
            branchPhone: "",
            statusName: "",
            statusCode: "",
            branchCode: "",
            createdDate: "",
            updatedDate: "",
          };
          const updatedBranchList = [newBranch, ...res.data.data];
          setBranchListTable(updatedBranchList);
        } else {
          setBranchList([]);
          setBranchListTable([]);
          setError(res.message);
        }
      } catch (err) {
        setBranchList([]);
        setBranchListTable([]);
        setError(err.message || "Failed to fetch branches");
      } finally {
        setIsLoading(false);
      }
    };

    fetchBranches();
  }, [searchBranchName]);

  return {
    branchList,
    branchListTable,
    searchBranchName,
    setSearchBranchName,
    isLoading,
    error,
  };
};

export default useBranches;
